import { Link } from 'react-router-dom';
import { Logo } from './Logo';
import { MapPin, Mail, Phone } from 'lucide-react';

export const Footer = () => (
  <footer className="mt-16 pt-12 pb-24 md:pb-12 bg-[#0E3F80] text-white">
    <div className="max-w-7xl mx-auto px-4 md:px-6 grid grid-cols-2 md:grid-cols-4 gap-8">
      <div className="col-span-2">
        <div className="flex items-center gap-3 mb-3">
          <div className="bg-white rounded-xl p-2 shadow-md flex-shrink-0">
            <img src="/branding/logo-jobkongo.png" alt="Job Kongo" width={48} height={42} className="object-contain block" style={{ height: 42 }} />
          </div>
          <div className="leading-tight">
            <p className="text-2xl font-bold tracking-tight" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
              Job<span className="text-[#F7D618]">Kongo</span>
            </p>
            <p className="text-xs text-[#FFE36B] font-medium">Mosala na confiance</p>
          </div>
        </div>
        <p className="text-sm text-white/80 max-w-sm">La plateforme de services de proximité en République Démocratique du Congo. Du travail en confiance, partout en RDC.</p>
        <div className="mt-4 space-y-1.5 text-sm text-white/80">
          <p className="flex items-center gap-2"><MapPin size={14} /> Kinshasa, RDC</p>
          <p className="flex items-center gap-2"><Mail size={14} /> hello@jobkongo.com</p>
          <p className="flex items-center gap-2"><Phone size={14} /> +243 000 000 000</p>
        </div>
      </div>
      <div>
        <p className="font-semibold mb-3 text-white">Plateforme</p>
        <ul className="space-y-2 text-sm text-white/80">
          <li><Link to="/how-it-works">Comment ça marche</Link></li>
          <li><Link to="/trust">Confiance & sécurité</Link></li>
          <li><Link to="/ambassadors">Ambassadeurs</Link></li>
          <li><Link to="/blog">Blog & conseils</Link></li>
          <li><Link to="/faq">FAQ</Link></li>
        </ul>
      </div>
      <div>
        <p className="font-semibold mb-3 text-white">Légal</p>
        <ul className="space-y-2 text-sm text-white/80">
          <li><Link to="/terms">CGU</Link></li>
          <li><Link to="/privacy">Confidentialité</Link></li>
          <li><Link to="/code-of-conduct">Code de conduite</Link></li>
        </ul>
      </div>
    </div>
    <div className="mt-12 border-t border-white/10 pt-6 px-4 max-w-7xl mx-auto text-xs text-white/70 text-center">
      © {new Date().getFullYear()} Job Kongo — Tous droits réservés.
    </div>
  </footer>
);
